__turbopack_context__.v({
  "wrapper": "SearchFormTabs-module__Y91vUG__wrapper",
});
